import { db } from "@/firebaseConfig";
const orderCommentsCollection = db.collection("order_comments");

const saveOrderComment = async data => {
  orderCommentsCollection
    .doc()
    .set(data)
    .then(() => {
      console.log("OrderComment successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const updateOrderComment = async (id, data) => {
  orderCommentsCollection
    .doc(id)
    .update(data)
    .then(() => {
      console.log("OrderComment successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const deleteOrderComment = async id => {
  orderCommentsCollection
    .doc(id)
    .delete()
    .then(() => {
      console.log("OrderComment successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const getOrderCommentById = async id => {
  return orderCommentsCollection
    .doc(id)
    .get()
    .then(doc => {
      return doc.exists ? doc.data() : null;
    })
    .catch(error => {
      throw error;
    });
};

export {
  orderCommentsCollection,
  saveOrderComment,
  updateOrderComment,
  deleteOrderComment,
  getOrderCommentById
};
